module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "margin": "12px",
      "color": "#000"
    }
  }, [_c('h1', {
    staticStyle: {
      "text-align": "center",
      "border-bottom": "4px solid #000"
    }
  }, [_vm._v(" NOTA ")]), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('section', [_c('table', {
    staticStyle: {
      "width": "60%",
      "float": "left"
    }
  }, [_c('tr', [_c('td', [_vm._v("Marking")]), _vm._v(" "), _c('td', [_vm._v(":")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.kontras.markingcode))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Bapak / Ibu")]), _vm._v(" "), _c('td', [_vm._v(":")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-transform": "uppercase"
    }
  }, [_vm._v(_vm._s(_vm.kontras.markinginfoname))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Telepon")]), _vm._v(" "), _c('td', [_vm._v(":")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.kontras.markinginfophone1))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Alamat")]), _vm._v(" "), _c('td', [_vm._v(":")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.kontras.markinginfoaddress1))])])]), _vm._v(" "), _c('table', {
    staticStyle: {
      "width": "30%",
      "float": "right"
    }
  }, [_c('tr', [_c('td', [_vm._v("Tgl. Nota")]), _vm._v(" "), _c('td', [_vm._v(":")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("dateFormatted2")(_vm.kontras.kontraCreatedAt)))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Jatuh Tempo")]), _vm._v(" "), _c('td', [_vm._v(":")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.kontras.dueDateDay) + " Hari")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Tgl. Jatuh Tempo")]), _vm._v(" "), _c('td', [_vm._v(":")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("dateFormatted2")(_vm.kontras.lastInvoicedateDue)))])])])]), _vm._v(" "), _c('br'), _c('br'), _c('br'), _c('br'), _c('br'), _c('br'), _c('br'), _vm._v(" "), _c('section', [_c('table', {
    attrs: {
      "width": "100%"
    }
  }, [_vm._m(0), _vm._v(" "), _c('tbody', [_vm._l((_vm.kontras.invoices), function(invoice, idx) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(++idx))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("dateFormatted2")(invoice.loaddate)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(invoice.containercode))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("dateFormatted2")(invoice.loaddate)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(invoice.detail.mainFees[0].ongkir.noIndex))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "text-transform": "uppercase"
      }
    }, [_vm._v(_vm._s(invoice.detail.mainFees[0].item))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(invoice.totalctns))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("toFixed3")(invoice.totalvolume != "0.000000" ? invoice.totalvolume : invoice.totalgw)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("numberFormatted")(invoice.detail.mainFees[0].ongkir.markingprice)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("numberFormatted")(invoice.invoicefee)))])])
  }), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "custom-td",
    attrs: {
      "colspan": "2"
    }
  }), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('td', {
    staticClass: "custom-td"
  }, [_c('strong', [_vm._v(_vm._s(_vm._f("numberFormatted")(_vm.kontras.grandTotal)))])])]), _vm._v(" "), _c('br'), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('br'), _c('br'), _c('br'), _c('br'), _vm._v(" "), _vm._m(3)], 2)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("NO")]), _vm._v(" "), _c('th', [_vm._v("LOAD")]), _vm._v(" "), _c('th', [_vm._v("PARTAI")]), _vm._v(" "), _c('th', [_vm._v("BONGKAR")]), _vm._v(" "), _c('th', [_vm._v("INDEX")]), _vm._v(" "), _c('th', [_vm._v("ITEM")]), _vm._v(" "), _c('th', [_vm._v("CTNS")]), _vm._v(" "), _c('th', [_vm._v("VOL/GW")]), _vm._v(" "), _c('th', [_vm._v("HARGA")]), _vm._v(" "), _c('th', [_vm._v("TOTAL")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {
    staticClass: "custom-td",
    attrs: {
      "colspan": "7"
    }
  }, [_c('strong', [_vm._v("GRAND TOTAL")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', {
    attrs: {
      "colspan": "3"
    }
  }, [_c('strong', [_vm._v("Diketahui")])]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "4"
    }
  }, [_c('strong', [_vm._v("Diterima Oleh,")])]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "3"
    }
  }, [_c('strong', [_vm._v("Kembali Tanggal :")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', {
    attrs: {
      "colspan": "3"
    }
  }), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "4"
    }
  }, [_c('strong', [_vm._v("Nama Jelas TTD / Cap Perusahaan")])]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "3"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7ddd66d0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/kontra/pdfKontraRePrint.vue
// module id = 1840
// module chunks = 1